import React, { useMemo } from 'react';
import { Accordion, AccordionItem, Button } from '../../Common';
// import { UserWithPicture } from '../LeaveRequestPartials';÷

import { Link } from 'react-router-dom';
import { OrganizationMembersWithBranchDataDto } from '../../../commonTypes/acs';
import { useTranslation } from '../../../hooks/useTranslation';
import { Translation } from '../../../commonTypes/translation.types';
import { UserWithPicture } from '../../LeaveRequestPartials';

interface IMembersAccordion {
    member: OrganizationMembersWithBranchDataDto;
    openDeleteModal: () => void;
    openEditModal: () => void;
    selectedOrganizationPolicyId: string;
}

export const MembersAccordion = ({ member, openDeleteModal, openEditModal, selectedOrganizationPolicyId }: IMembersAccordion) => {
    const { t } = useTranslation();

    const policyIndex = useMemo(() => {
        return member.policies.findIndex(policy => policy.organizationPolicyId === selectedOrganizationPolicyId);
    }, [member, selectedOrganizationPolicyId]);

    const tableLeaveType = member.policies.length ? member.policies[0].leaveType : t('leaveRequest.availableDays');

    return (
        <div className="organization-members__accordion">
            <Accordion
                headerElement={
                    <Link to={`/profile/${member.userSub}`}>
                        <UserWithPicture firstName={member.givenName} lastName={member.familyName} imgUrl={member.imageUrl} email={member.email} />
                    </Link>
                }
            >
                <AccordionItem title={t('common.role')} value={t(`db_keywords.${member.role.name}` as keyof Translation)} blueText />
                <AccordionItem
                    title={tableLeaveType}
                    value={
                        <>
                            {policyIndex !== -1 ? (
                                <>
                                    <span className="organization-members__days--amount">{member.policies[policyIndex].amount}</span>/
                                    {member.policies[policyIndex].initialAmount}
                                    {t('leaveRequest.dayUnit')}
                                </>
                            ) : (
                                <span className="paragraph-3">{t('members.noPolicyMessage')}</span>
                            )}
                        </>
                    }
                />

                <div className="accordion__buttons">
                    <Button text={t('members.removeUser')} onClick={openDeleteModal} variant="text" color="error" />
                    <Button text={t('members.editPolicy')} onClick={openEditModal} variant="text" color="gray" />
                </div>
            </Accordion>
        </div>
    );
};
